import { useTranslation } from "react-i18next";
import ExoTabs from "../../components/exo/ExoTabs";
import Header from "../../components/special/Header";
import TimesheetsTab from "./timesheets/TimesheetsTab";
import AccountingTab from "./accounting/AccountingTab";

const TaxConsultant = () => {
  const { t } = useTranslation();
  const tabs = [
    {
      label: t("Timesheets"),
      content: <TimesheetsTab />,
    },
    {
      label: t("Accounting"),
      content: <AccountingTab />,
    },
  ];

  /*
    {
      label: t("Finance Reports"),
      content: <Box>TEST2</Box>,
    },
    {
      label: t("Social Insurance"),
      content: <Box>TEST2</Box>,
    },
    {
      label: t("Input Tax"),
      content: <Box>TEST2</Box>,
    },
    {
      label: t("Tax Return"),
      content: <Box>TEST2</Box>,
    },*/

  return (
    <>
      <Header title={t("Tax Consultant")} />
      <ExoTabs orientation="vertical" tabs={tabs} />
    </>
  );
};

export default TaxConsultant;
